import enhance from "./enhancer"
import NewApplicationModal from "./NewApplicationModal"

export default enhance(NewApplicationModal)
